import { render, staticRenderFns } from "./AplicarAumento.vue?vue&type=template&id=2dc00ef9&"
import script from "./AplicarAumento.vue?vue&type=script&lang=js&"
export * from "./AplicarAumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports